function replaceLooxReviewLabel() {
  const ratingLabel = document.querySelector('.loox-rating-label');
  if (ratingLabel) {
    const match = ratingLabel.textContent.match(/\d+/);
    if (match) {
      const count = parseInt(match[0], 10);
      const label = count === 1 ? "Avis" : "Avis";
      ratingLabel.innerHTML = `&nbsp;${count} ${label}`;
    }
  }
}

const observer = new MutationObserver(() => {
  const label = document.querySelector('.loox-rating-label');
  if (label) {
    replaceLooxReviewLabel();
    observer.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});
